import { render, staticRenderFns } from "./Hlx.vue?vue&type=template&id=24edb15c&scoped=true&"
import script from "./Hlx.vue?vue&type=script&lang=js&"
export * from "./Hlx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24edb15c",
  null
  
)

export default component.exports